<template>

    <BaseDialog
        :showDialog="showMediaFileUploadDialog"
        maxDialogWidth="800"
        maxCardHeight="600"
        :headline="headline"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-drag-and-drop'">
                        <VueFileAgent
                                    ref="mediaFileUploader"
                                    :thumbnailSize="120"
                                    :theme="'list'"
                                    :accept="acceptedFiles"
                                    :multiple="true"
                                    :deletable="true"
                                    :errorText="errorProps"
                                    @beforedelete="removeMediaFile($event)"
                                    @select="mediaFileSelected($event)"
                                    :averageColor="true"
                                    :helpText="$t(placeholder)"
                                >
                        </VueFileAgent>

                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="d-flex justify-end pl-0" align-self="center">
                            <BaseButton
                                label="lang_GENERAL_CAPTION_UPLOAD"
                                @click="uploadMediaFiles()"
                                :alvqa="alvqa+'-button-image-upload'"
                                :disabled="shouldDisableButton"
                            /> 
                        </v-col>
                    </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import api from '@/api_alv'

export default {

    name:'MediaFileUploadDialog',

    props:{
        headline:{
            type: String
        },
        acceptedFiles:{
            type:String
        },
        placeholder:{
            type:String
        },
        context:{
            type:String
        },
        detailsCall:{
            type:String
        },
        directory:{
            type:String
        },
    },

    components:{
        BaseDialog,
        BaseButton,
    },

    data(){
        return {
            alvqa : "media-file-upload-dialog",
            formData: new FormData(),
            isUploading:false,
            errorProps: {
                type:this.$t('lang_GENERIC_DRAG_AND_DROP_UPLOADER_WRONG_FILE_FORMAT'),
                size: 'You selected a larger file!',
            },
        }
    },

    computed: {
        showMediaFileUploadDialog: {
            get() { return this.$store.getters.getShowMediaFileUploadDialog },
            set(show) { this.$store.commit('setShowMediaFileUploadDialog', show) }
        },
        selected: {
            get() { return this.$store.getters.getSelectedMediaUploadFiles },
            set( item ) { this.$store.commit('setSelectedMediaUploadFiles', item)},
        },
        shouldDisableButton() {
            return this.isUploading || this.selected.length === 0;
       }
    },

    methods:{
        closeDialog() {
            this.selected = []
            this.$refs.mediaFileUploader.fileRecords = []
            this.showMediaFileUploadDialog = false
            // this.$store.dispatch("fetchTracksMedia")
            this.$store.dispatch("fetch" + this.context)
        },
        mediaFileSelected(mediaFilesSelected){
            let validFile = mediaFilesSelected.filter(mediaFile => mediaFile.error === false)
            this.selected = this.selected.concat(validFile)
        },
        removeMediaFile(mediaFile){
            let index = this.selected.indexOf(mediaFile)

            /*File was not added into the array of all selected files because of the wrong
              format, but still being added to fileRecord in mediaFileUploader (visualy) 
              To delete a file with a wrong format from the list.
             */
            if(mediaFile.error !== false){
                this.$refs.mediaFileUploader.deleteFileRecord(mediaFile)
            }
            //File was found in the Array of all selected Files and will be removed
            // from file uloader and from the array 
            if(index !== -1){
                this.selected.splice(index,1)
                this.$refs.mediaFileUploader.deleteFileRecord(mediaFile)
            }

        },
   async uploadMediaFiles(){
            this.isUploading = true;
            let alvId = this.$store.getters[this.detailsCall].alvId
            let root = api.getRootUrl()

            this.uploadHeaders = {
            Authorization: "Bearer " + this.$store.getters.getUserToken()
            }
            this.uploadUrl = root + this.directory + alvId + '/files'



         let response = await this.$refs.mediaFileUploader.upload(
            this.uploadUrl,
            this.uploadHeaders,
            this.selected,
            function createFormData(fileData){
                var formData = new FormData();
                formData.append('file', fileData.file); // this is important! - the actual file for upload
                return formData;
            }
        );
        response = JSON.parse(response[0].request.response)
        if (response.error === 1) {
            this.$store.commit('setSnackbar', {
                type: 'error',
                msg:  response.response.errorMsg
            })
        }
        this.isUploading = false;
        this.closeDialog()

            
        }

    }

}
</script>

<style>

</style>